<template>
	<transition name="block" mode="out-in">
		<div class="vstack gap-1 h-100 justify-content-center position-relative mx-auto text-center align-items-center lh-xs" v-if="show">
			<img :src="assetsImgLogoComplete" class="h-rem-8 logo" alt="logo">
			<div class="text-muted" v-if="text">{{ text }}</div>
		</div>
	</transition>
</template>

<script>
	import { ref, onMounted } from 'vue';
	import assetsImgLogoComplete from '@/assets/img/logo/complete.png';

	export default {
		props: {
			text: String
		},
		setup(props) {
			const show = ref(false);

			onMounted(() => {
				show.value = true;
			});

			return { assetsImgLogoComplete, show };
		}
	}
</script>

<style scoped>
	.logo {
		display: block;
		width: auto;
		height: auto;
	}

	.block-enter-from { opacity: 0; }
	.block-enter-to { opacity: 1; }

	.block-enter-active, .block-leave-active { transition: all 3s ease; }
</style>